import React, { useMemo, useState } from 'react'
import styles from './PaymentsPage.module.scss'
import { useCrmInfo } from '../../components/CrmLayout/CrmLayout.context'
import { ITableState } from '@utils/sort'
import { initialPagination } from '../../../MainPage/MainPage'
import moment from 'moment'
import RangePickerUi from '@components/ui/RangePickerUi/RangePickerUi'
import CustomTable from '@components/ui/CustomTable/CustomTable'
import { Spin } from 'antd'
import useCrmPaymentsApi from '@api/useCrmPayments'
import { crmPaymentsColumns } from './paymants.column'
import { fullDateFormat } from '@utils/time'
import WithLabel from '@components/ui/WithLabel/WithLabel'
import { antIcon } from '@components/TopUsers/TopUsers'
import Box from '@components/ui/Box/Box'
import { IconCalendar } from '@utils/icons'

const PaymentPage: React.FC = () => {
  const [crmInfo] = useCrmInfo()
  const [state, setState] = useState<ITableState>(initialPagination)
  const [selectedDate, setSelectedDate] = useState<[moment.Moment | null, moment.Moment | null]>([
    moment().startOf('year'),
    moment().endOf('year'),
  ])

  const { result } = useCrmPaymentsApi({
    crmId: crmInfo?.id,
    dates: selectedDate,
    pagination: state,
  })

  const mapped = useMemo(() => {
    return (
      result?.rows.map((el) => {
        return {
          ...el,
          createdAt: fullDateFormat(el.createdAt),
        }
      }) ?? []
    )
  }, [result])

  return (
    <Box className={styles.container}>
      <div className={styles.header}>
        <WithLabel
          label='Выберите период времени:'
          icon={<IconCalendar width='18' height='18' fill='var(--color-main)' />}
        >
          <RangePickerUi value={selectedDate} onChange={setSelectedDate} allowClear={false} />
        </WithLabel>
      </div>
      <div className={styles.table}>
        {mapped ? (
          <CustomTable
            columns={crmPaymentsColumns}
            dataSource={mapped}
            allCount={result?.count ?? 0}
            updatePagination={setState}
            pagination={state.pagination}
          />
        ) : (
          <div className={styles.loadWrapp}>
            <Spin indicator={antIcon} className={styles.loadSpin} />
          </div>
        )}
      </div>
    </Box>
  )
}

export default PaymentPage
